var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { DraftType } from "@@/Draft";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { observable, action, makeObservable } from "mobx";
import { DiagramPropertyState } from "@/app/UIComponents/DiagramPropertyDialog";
import { DiagramPropertyPaneState } from "@/app/UIComponents/DiagramPrpertyPane";
import streamSaver from "streamsaver";
import { NoteStatus } from "@@/Annotation";
import { CommentState } from "@/app/UIComponents/Comments";
export class AdminDraftDetailViewStore {
    constructor() {
        this.loadingdetails = false;
        this.edittingrequest = false;
        this.showexpendedview = false;
        this.showdraftingview = false;
        this.savingdraft = false;
        this.lockupdating = false;
        this.lockerror = "";
        this.publishing = false;
        this.processpaste = false;
        this.viewing = false;
        this.view = "detail";
        this.exportstatus = new Map();
        this.exportstatusdetail = false;
        this.drafttype = DraftType.DOCX;
        this.diagramPropertyState = new DiagramPropertyState();
        this.diagrapmpropertypanel = new DiagramPropertyPaneState();
        this.showpropertybox = false;
        this.updateinglocktimeout = -1;
        this.draftid = "";
        this.draftname = "";
        this.letrid = "";
        this.accesskey = "";
        this.cref = null;
        this.activeinitdraftcontent = "";
        this.spreadsheetref = null;
        this.activdatasheet = null;
        this.dref = null;
        this.requestingexcelexport = false;
        this.objectid = "";
        this.readonlymode = false;
        this.activeuserid = "";
        this.loadingcomments = false;
        this.editnoteid = "";
        this.editmode = false;
        this.showcomments = false;
        this.notesbyid = new Map();
        this.commentstate = new CommentState();
        this.startindex = "";
        this.endindex = "";
        this.selectedrange = "";
        this.activesheetid = "";
        this.lastcommenttime = -1;
        this.activerequestid = "";
        this.shownotespanel = true;
        this.spreadhseetcreated = false;
        this.scrollnoteid = "";
        this.loading = false;
        this.lastnotesupdatetime = -1;
        this.enableannotation = false;
        this.rendering = true;
        makeObservable(this);
        APPEvent.addSubscriberForAdminSpreadsheetCont((con) => {
            if (!con.floating && con.userid === this.activeuserid) {
                this.activeinitdraftcontent = con.content;
                this.setReadonlyMode(con.readonly);
            }
        });
        APPEvent.addSubscriberForAdminLetrChanged((letr) => {
            if (this.letrid !== letr.id) {
                this.letrid = letr.id;
                this.resetNotes();
            }
        });
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.activeuserid = useird;
        });
        APPEvent.addSubscriberForAdminGetNote((notes) => {
            if (notes.ischooser || notes.userid !== this.activeuserid || notes.letrid !== this.letrid) {
                return;
            }
            if (notes.letrid === this.letrid && notes.objectid === this.objectid) {
                notes.note.forEach((n) => {
                    if (n.status === NoteStatus.Dead) {
                        this.removeNote(n.id);
                    }
                    else {
                        this.addNote(n);
                    }
                });
                this.setLoadingNotes(false);
                this.scrollToNote();
                // this.notestimeout = setTimeout(() => this.getNotesUpdate(), 10000);
            }
        });
        APPEvent.addSubscriberForDraftExport((ex) => {
            if (this.requestingexcelexport) {
                if (ex === undefined || (ex.draftid === this.draftid && !ex.submitted)) {
                    APPEvent.publishApperror("Sorry, failed to export. Please try again later");
                    this.setRequestingExportExcel(false);
                }
                else if (ex.draftid === this.draftid) {
                    APPEvent.publishApperror("Successfully, submitted export to encryoted LRVM. Monitor progress using export manager");
                    this.setRequestingExportExcel(false);
                }
            }
        });
        APPEvent.addSubscriberForDraftPublished((pub) => {
            if (this.publishing && pub.draftid === this.draftid) {
                if (!pub.result) {
                    APPEvent.publishApperror("Sorry, failed to publish the draft. Please try again");
                }
                this.loadDraftDetail(true);
                this.setPublishing(false);
            }
        });
        APPEvent.addSubscriberForFormatPaste((data) => {
            var _a;
            if (this.processpaste && data !== undefined) {
                // okay we do
                (_a = this.cref) === null || _a === void 0 ? void 0 : _a.documentEditor.editor.paste(data);
                this.setPasteProcessing(false);
            }
        });
        APPEvent.addSubscriberForSavedDraftContent((res) => {
            if (this.savingdraft && this.draftid === res.draftid) {
                if (!res) {
                    APPEvent.publishApperror("Sorry, failed to save the draft. Please try again");
                }
                this.setSavingDraft(false);
            }
        });
        APPEvent.addSubscriberForAdminDraftDetail((det) => {
            if ((det === null || det === void 0 ? void 0 : det.draftid) === this.draftid) {
                if (det.detail === undefined) {
                    APPEvent.publishApperror("Sorry, failed to load draft details");
                }
                else {
                    this.setDraftDetail(det.detail);
                }
                this.setLoadingDetails(false);
            }
        });
        APPEvent.addSubscriberForDraftStatus((st) => {
            if (st !== undefined && st.length > 0) {
                if (this.exportstatusdetail && st[0].draftid === this.draftid) {
                    for (const es of st) {
                        this.setExportStatus(es);
                    }
                    this.setReqExportStatusDetails(false);
                }
            }
            else if (this.exportstatusdetail) {
                this.setReqExportStatusDetails(false);
            }
        });
        APPEvent.addSubscriberForAdminDraftLockResponse((res) => {
            if (this.edittingrequest && res.draftid === this.draftid) {
                this.setEdittingRequest(false);
                this.setReadonlyMode(true);
                if (res.res === undefined) {
                    APPEvent.publishApperror("Sorry, something went wrong getting edit lock. Please try again later");
                    return;
                }
                this.loadDraftDetail(true);
                if (res.res.granted) {
                    // now we can just edit this now!
                    // get the latest content and we done here!
                    if (res.res.decryptedcontent) {
                        if (this.drafttype === DraftType.XLSX) {
                            res.res.decryptedcontent = LetrwingCrypto.getUTF8FromBase64(res.res.decryptedcontent);
                        }
                        this.activeinitdraftcontent = res.res.decryptedcontent;
                    }
                    else {
                        this.activeinitdraftcontent = "";
                    }
                    this.setShowDraftingView(true);
                    this.updateinglocktimeout = setTimeout(() => this.lockPing(), 10000);
                }
                else if (res.res.currentlockusername) {
                    APPEvent.publishApperror("Sorry, " + res.res.currentlockusername + " is editting this document. Please request them to release the edit lock");
                    return;
                }
                else {
                    APPEvent.publishApperror("Sorry, something went wrong getting edit lock. Please try again later");
                    return;
                }
            }
            else if (this.viewing && res.draftid === this.draftid) {
                this.setViewingRequest(false);
                this.setReadonlyMode(true);
                if (res.res === undefined) {
                    APPEvent.publishApperror("Sorry, something went wrong getting content. Please try again later");
                    return;
                }
                if (res.res.decryptedcontent) {
                    if (this.drafttype === DraftType.XLSX) {
                        res.res.decryptedcontent = LetrwingCrypto.getUTF8FromBase64(res.res.decryptedcontent);
                    }
                    this.activeinitdraftcontent = res.res.decryptedcontent;
                }
                else {
                    this.activeinitdraftcontent = "";
                }
                this.setShowDraftingView(true);
            }
        });
        APPEvent.addSubscriberForUpdateDraftLock((lock) => {
            if (lock.id === this.draftid && this.lockupdating) {
                this.setLockUpdating(false);
                if (lock.updated) {
                    this.updateinglocktimeout = setTimeout(() => this.lockPing(), 10000);
                }
                else {
                    this.setLockError("Seems like you dont have edit lock. Please try again using edit button");
                }
            }
        });
        this.diagrapmpropertypanel.oncancel = () => {
            this.setShowPropertyPane(false);
        };
        this.diagrapmpropertypanel.onok = () => {
            var _a, _b, _c, _d;
            (_b = (_a = this.dref) === null || _a === void 0 ? void 0 : _a.selectedItems.nodes) === null || _b === void 0 ? void 0 : _b.forEach((node) => {
                var _a;
                // node.backgroundColor = this.diagramPropertyState.color;
                if (node.style) {
                    node.style.fill = this.diagrapmpropertypanel.color;
                    node.style.strokeColor = this.diagrapmpropertypanel.bordercolor;
                }
                (_a = node.annotations) === null || _a === void 0 ? void 0 : _a.forEach((ano) => {
                    if (ano.style) {
                        ano.style.color = this.diagrapmpropertypanel.textcolor;
                        ano.style.bold = this.diagrapmpropertypanel.boldtext;
                        ano.style.italic = this.diagrapmpropertypanel.italictext;
                        if (this.diagrapmpropertypanel.fontsize > 0) {
                            ano.style.fontSize = this.diagrapmpropertypanel.fontsize;
                        }
                        ano.style.textAlign = this.diagrapmpropertypanel.textalign;
                    }
                });
            });
            (_d = (_c = this.dref) === null || _c === void 0 ? void 0 : _c.selectedItems.connectors) === null || _d === void 0 ? void 0 : _d.forEach((conn) => {
                if (conn.style) {
                    conn.style.strokeColor = this.diagrapmpropertypanel.color;
                    conn.style.fill = this.diagrapmpropertypanel.color;
                }
            });
        };
    }
    setRendering(ren) {
        this.rendering = ren;
    }
    setEnableAnnotation(enable) {
        this.enableannotation = enable;
    }
    addNote(note) {
        this.notesbyid.set(note.id, note);
    }
    removeNote(nid) {
        this.notesbyid.delete(nid);
    }
    getAllNotes() {
        if (this.loading) {
            return;
        }
        this.lastnotesupdatetime = -1;
        this.setLoadingNotes(true);
        const req = {
            letrid: this.letrid,
            objectid: this.objectid,
            referencid: this.draftid,
            ischooser: false,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admingetnotes", req);
    }
    setLoadingNotes(loading) {
        this.loading = loading;
    }
    setSpreadsheetCreated(created) {
        this.spreadhseetcreated = created;
        this.scrollToNote();
    }
    scrollToNote() {
        if (this.scrollnoteid && this.spreadsheetref && this.spreadhseetcreated && this.notesbyid.size > 0) {
            setTimeout(() => {
                var _a;
                if (this.scrollnoteid && this.spreadsheetref && this.notesbyid.size > 0) {
                    const n = this.notesbyid.get(this.scrollnoteid);
                    if (n) {
                        const parts = n.data.match.split(":");
                        let text = " ";
                        let totext = "";
                        let sindex = "";
                        let eindex = "";
                        let address = "";
                        if (parts.length > 2) {
                            try {
                                sindex = parts[1];
                                const en = parts[2];
                                const eparts = en.split(";");
                                eindex = eparts[0];
                                address = eparts[0] + ":" + eparts[1];
                                text += address;
                                const index = parseInt(sindex);
                                if (this.spreadsheetref.sheets.length >= index) {
                                    const name = this.spreadsheetref.sheets[index - 1].name;
                                    (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.goTo(name + "!" + eindex);
                                }
                                setTimeout(() => {
                                    var _a;
                                    (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.selectRange(address);
                                    this.setSelectedRange(address);
                                }, 100);
                            }
                            catch (ex) {
                                console.log(ex);
                            }
                        }
                    }
                    this.scrollnoteid = "";
                }
            }, 100);
        }
    }
    setShowNotesPanel(show) {
        this.shownotespanel = show;
    }
    setSelectedRange(ran) {
        this.selectedrange = ran;
    }
    setEditMode(mode) {
        this.editmode = mode;
    }
    setEditNoteId(id) {
        this.editnoteid = id;
        this.setLoadingComments(false);
        this.commentstate.clear();
        this.loadComments();
        this.lastcommenttime = -1;
    }
    setActiveSheetId(id) {
        this.activesheetid = id;
    }
    setShowComments(dn) {
        this.showcomments = dn;
    }
    setLoadingComments(loading) {
        this.loadingcomments = loading;
    }
    loadComments() {
        if (this.loadingcomments || !this.editnoteid) {
            return;
        }
        this.setLoadingComments(true);
        const getcoom = {
            letrid: this.letrid,
            objectid: this.objectid,
            noteid: this.editnoteid,
            userid: this.activeuserid,
            floating: false
        };
        Apphandler.sendMessage("admingetcomments", getcoom);
    }
    resetNotes() {
        this.notesbyid.clear();
        this.setShowComments(false);
    }
    formatPaste(cont) {
        this.setPasteProcessing(true);
        Apphandler.sendMessage("formatpaste", cont);
    }
    loadDraftDetail(silent = false) {
        if (this.loadingdetails || !this.activeuserid) {
            return;
        }
        if (!silent) {
            this.setLoadingDetails(true);
        }
        // now lets 
        const req = {
            letrid: this.letrid,
            draftid: this.draftid,
            accesskey: this.accesskey,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admindraftdetails", req);
    }
    requestView() {
        if (this.viewing || this.edittingrequest || !this.activeuserid) {
            return;
        }
        this.setViewingRequest(true);
        const req = {
            letrid: this.letrid,
            id: this.draftid,
            accesskey: this.accesskey,
            readonlymode: true,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admindraftview", req);
    }
    requestEdit() {
        if (this.viewing || this.edittingrequest) {
            return;
        }
        this.setEdittingRequest(true);
        const req = {
            letrid: this.letrid,
            id: this.draftid,
            accesskey: this.accesskey,
            readonlymode: false,
            objectid: this.objectid,
            origid: this.objectid
        };
        Apphandler.sendMessage("draftedit", req);
    }
    lockPing() {
        const req = {
            id: this.draftid,
            letrid: this.letrid
        };
        this.setLockUpdating(true);
        Apphandler.sendMessage("updateDraftLock", req);
    }
    async saveExcel() {
        var _a, _b, _c;
        this.setSavingDraft(true);
        (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.endEdit();
        const data = await ((_b = this.spreadsheetref) === null || _b === void 0 ? void 0 : _b.saveAsJson());
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            content: LetrwingCrypto.getBase64FromUT8((_c = JSON.stringify(data)) !== null && _c !== void 0 ? _c : '')
        };
        this.setSavingDraft(true);
        Apphandler.sendMessage("savedraftcontet", req);
    }
    async saveDiagram() {
        var _a;
        this.setSavingDraft(true);
        const diagram = (_a = this.dref) === null || _a === void 0 ? void 0 : _a.saveDiagram();
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            content: diagram !== null && diagram !== void 0 ? diagram : ''
        };
        this.setSavingDraft(true);
        Apphandler.sendMessage("savedraftcontet", req);
    }
    saveContent() {
        var _a;
        if (this.drafttype === DraftType.Diagram) {
            this.saveDiagram();
            return;
        }
        if (this.drafttype === DraftType.XLSX) {
            this.saveExcel();
            return;
        }
        const cont = (_a = this.cref) === null || _a === void 0 ? void 0 : _a.documentEditor.serialize();
        // lets now save this 
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            content: cont !== null && cont !== void 0 ? cont : ''
        };
        this.setSavingDraft(true);
        Apphandler.sendMessage("savedraftcontet", req);
    }
    setExportStatus(sta) {
        this.exportstatus.set(sta.id, sta);
    }
    getExportStatus() {
        this.setReqExportStatusDetails(true);
        this.exportstatus.clear();
        this.setView("exportmanager");
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            data: ""
        };
        Apphandler.sendMessage("draftexportstatus", req);
    }
    setReqExportStatusDetails(req) {
        this.exportstatusdetail = req;
    }
    setRequestingExportExcel(req) {
        this.requestingexcelexport = req;
    }
    setView(view) {
        this.view = view;
    }
    // for desktop this need to be slightly different 
    // maybe done via background
    async downloadData(data) {
        const bytes = LetrwingCrypto.base64ToBin(data);
        const fileStream = streamSaver.createWriteStream(this.draftname + ".xlsx", {
            size: bytes.length,
            writableStrategy: undefined,
            readableStrategy: undefined // (optional)
        });
        const writer = fileStream.getWriter();
        await writer.write(bytes);
        await writer.close();
    }
    async exportExcel() {
        var _a, _b;
        (_a = this.spreadsheetref) === null || _a === void 0 ? void 0 : _a.endEdit();
        const data = await ((_b = this.spreadsheetref) === null || _b === void 0 ? void 0 : _b.saveAsJson());
        this.setRequestingExportExcel(true);
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            data: data ? LetrwingCrypto.getBase64FromUT8(JSON.stringify(data.jsonObject.Workbook)) : ''
        };
        Apphandler.sendMessage("draftexport", req);
    }
    getDiagramData() {
        var _a;
        return (_a = this.dref) === null || _a === void 0 ? void 0 : _a.exportDiagram({ fileName: this.draftname, format: 'PNG', mode: 'Data' });
    }
    exportDraft() {
        if (this.drafttype === DraftType.Diagram) {
            this.exportDiagram();
        }
        else if (this.drafttype === DraftType.DOCX) {
            this.exportDocx();
        }
        else if (this.drafttype === DraftType.XLSX) {
            this.exportExcel();
        }
    }
    exportDiagram() {
        var _a;
        const blob = (_a = this.dref) === null || _a === void 0 ? void 0 : _a.exportDiagram({ fileName: this.draftname, format: 'PNG', mode: 'Download' });
        if (typeof blob === 'string') {
            const link = document.createElement("a");
            link.href = blob;
            link.download = this.draftname + ".png";
            link.click();
        }
    }
    exportDocx() {
        var _a;
        (_a = this.cref) === null || _a === void 0 ? void 0 : _a.documentEditor.save(this.draftname, "Docx");
    }
    publishDraft() {
        var _a;
        const cont = (_a = this.cref) === null || _a === void 0 ? void 0 : _a.documentEditor.serialize();
        // lets now save this 
        const req = {
            draftid: this.draftid,
            letrid: this.letrid,
            accesskey: this.accesskey,
            content: cont !== null && cont !== void 0 ? cont : ''
        };
        this.setPublishing(true);
        Apphandler.sendMessage("publishdraftcontent", req);
    }
    setPasteProcessing(processing) {
        this.processpaste = processing;
    }
    setShowPropertyPane(show) {
        this.showpropertybox = show;
    }
    setPublishing(publishing) {
        this.publishing = publishing;
    }
    setLockUpdating(updating) {
        this.lockupdating = updating;
    }
    setLockError(error) {
        this.lockerror = error;
    }
    setSavingDraft(saving) {
        this.savingdraft = saving;
    }
    setShowExapndedView(expand) {
        this.showexpendedview = expand;
    }
    setShowDraftingView(view) {
        this.showdraftingview = view;
        if (!view) {
            this.setLockUpdating(false);
            if (this.updateinglocktimeout !== -1) {
                clearTimeout(this.updateinglocktimeout);
            }
        }
    }
    setEdittingRequest(req) {
        this.edittingrequest = req;
    }
    setViewingRequest(req) {
        this.viewing = req;
    }
    setReadonlyMode(readonlymode) {
        this.readonlymode = readonlymode;
    }
    setDraftDetail(detail) {
        this.details = detail;
    }
    setLoadingDetails(loadingdetails) {
        this.loadingdetails = loadingdetails;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "loadingdetails", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "details", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "edittingrequest", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "showexpendedview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "showdraftingview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "savingdraft", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "lockupdating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "lockerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "publishing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "processpaste", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "viewing", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminDraftDetailViewStore.prototype, "view", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminDraftDetailViewStore.prototype, "exportstatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "exportstatusdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "showpropertybox", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "requestingexcelexport", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "readonlymode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "loadingcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "editnoteid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "showcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminDraftDetailViewStore.prototype, "notesbyid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "selectedrange", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "activesheetid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "shownotespanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "spreadhseetcreated", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "enableannotation", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDraftDetailViewStore.prototype, "rendering", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setRendering", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setEnableAnnotation", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "addNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "removeNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setLoadingNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setSpreadsheetCreated", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setSelectedRange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setEditMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setEditNoteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setActiveSheetId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setShowComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setLoadingComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "resetNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "getExportStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setReqExportStatusDetails", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setRequestingExportExcel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setPasteProcessing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setShowPropertyPane", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setPublishing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setLockUpdating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setLockError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setSavingDraft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setShowExapndedView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setShowDraftingView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setEdittingRequest", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setViewingRequest", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setReadonlyMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setDraftDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDraftDetailViewStore.prototype, "setLoadingDetails", null);
